const doc = [({"da":({"js":({"admin":({"elements":({"table":({"view_element":"Se element"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;